import { OnnxFaceMatcher } from './OnnxFaceMatcher';

/**
 * Eagerly initialize ONNX models at app boot (fire-and-forget).
 *
 * Design decision #4 (Phase 3 spec):
 * - Uses existing `OnnxFaceMatcher.getInstance().initialize()` method
 * - Non-blocking: errors are logged but don't block app startup
 * - Idempotent: safe to call multiple times
 *
 * @returns Promise that resolves when models are loaded, or rejects if loading fails
 */
export function eagerInitializeOnnxModels(): Promise<void> {
  return OnnxFaceMatcher.getInstance()
    .initialize()
    .catch((err) => {
      console.warn('[App] ONNX models failed to load:', err);
    });
}
